import { BlogPost } from '../types/api';

export const mockBlogPosts: BlogPost[] = [
  {
    id: 1,
    title: "Direitos Trabalhistas: O que você precisa saber",
    slug: "direitos-trabalhistas-o-que-voce-precisa-saber",
    excerpt: "Entenda seus direitos como trabalhador e como buscar orientação jurídica adequada para proteger seus interesses.",
    content: `# Direitos Trabalhistas: O que você precisa saber

Os direitos trabalhistas são fundamentais para garantir a proteção do trabalhador no ambiente de trabalho. Neste artigo, vamos abordar os principais aspectos que todo trabalhador deve conhecer.

## Principais Direitos Trabalhistas

### 1. Jornada de Trabalho
- Limite de 8 horas diárias e 44 horas semanais
- Hora extra com adicional de 50%
- Descanso semanal remunerado

### 2. Férias
- Direito a 30 dias de férias por ano
- Pagamento de 1/3 constitucional
- Período de gozo não pode ser inferior a 14 dias

### 3. FGTS
- Depósito mensal de 8% sobre o salário
- Multa de 40% em caso de demissão sem justa causa
- Saque em situações específicas

## Como Buscar Orientação

Se você acredita que seus direitos foram violados, é importante buscar orientação jurídica especializada. Um advogado trabalhista pode ajudá-lo a:

- Analisar seu caso específico
- Calcular verbas rescisórias
- Entrar com ações trabalhistas
- Negociar acordos extrajudiciais

## Conclusão

Conhecer seus direitos trabalhistas é fundamental para se proteger no ambiente de trabalho. Não hesite em buscar orientação jurídica quando necessário.`,
    author: "Luara Rezende",
    date: "2025-01-15T10:00:00Z",
    read_time: "5 min",
    category: "Direitos Trabalhistas",
    tags: ["direitos", "trabalhista", "CLT", "orientação"],
    featured: true,
    image: "/images/blog/placeholder.jpg",
    created_at: "2025-01-15T10:00:00Z",
    updated_at: "2025-01-15T10:00:00Z"
  },
  {
    id: 2,
    title: "Rescisão de Contrato: Seus Direitos",
    slug: "rescisao-contrato-seus-direitos",
    excerpt: "Saiba quais são seus direitos na rescisão do contrato de trabalho e como calcular suas verbas rescisórias.",
    content: `# Rescisão de Contrato: Seus Direitos

A rescisão do contrato de trabalho é um momento delicado que envolve diversos direitos e obrigações. Vamos esclarecer os principais aspectos.

## Tipos de Rescisão

### 1. Demissão sem Justa Causa
- Aviso prévio de 30 dias
- Multa do FGTS de 40%
- 13º salário proporcional
- Férias proporcionais + 1/3

### 2. Demissão por Justa Causa
- Sem aviso prévio
- Sem multa do FGTS
- Apenas saldo de salário

### 3. Pedido de Demissão
- Aviso prévio de 30 dias
- Sem multa do FGTS
- Direito ao saque do FGTS

## Cálculo das Verbas

O cálculo das verbas rescisórias deve incluir:
- Saldo de salário
- 13º salário proporcional
- Férias proporcionais + 1/3
- Multa do FGTS (se aplicável)
- Aviso prévio (se aplicável)

## Conclusão

É fundamental conhecer seus direitos na rescisão para garantir que receba todas as verbas devidas.`,
    author: "Luara Rezende",
    date: "2025-01-10T14:30:00Z",
    read_time: "4 min",
    category: "Rescisão",
    tags: ["rescisão", "verbas", "FGTS", "demissão"],
    featured: false,
    image: "/images/blog/placeholder.jpg",
    created_at: "2025-01-10T14:30:00Z",
    updated_at: "2025-01-10T14:30:00Z"
  },
  {
    id: 3,
    title: "Horas Extras: Como Calcular",
    slug: "horas-extras-como-calcular",
    excerpt: "Aprenda a calcular corretamente suas horas extras e entenda quando você tem direito a esse adicional.",
    content: `# Horas Extras: Como Calcular

O trabalho em horas extras é uma realidade para muitos trabalhadores. Vamos esclarecer como calcular e quando você tem direito a esse adicional.

## Quando São Devidas as Horas Extras

### 1. Jornada Normal
- Limite de 8 horas diárias
- Limite de 44 horas semanais
- Qualquer trabalho além disso é hora extra

### 2. Adicional de Hora Extra
- 50% sobre o valor da hora normal
- Pagamento obrigatório
- Não pode ser compensado com folga

## Como Calcular

### Fórmula Básica
\`\`\`
Valor da Hora Extra = (Salário ÷ 220) × 1,5
\`\`\`

### Exemplo Prático
- Salário: R$ 2.200,00
- Hora normal: R$ 10,00
- Hora extra: R$ 15,00
- 10 horas extras = R$ 150,00

## Direitos do Trabalhador

- Pagamento mensal das horas extras
- Limite de 2 horas extras por dia
- Descanso mínimo de 11 horas
- Registro no ponto eletrônico

## Conclusão

As horas extras são um direito importante do trabalhador. Certifique-se de que estão sendo pagas corretamente.`,
    author: "Luara Rezende",
    date: "2025-01-05T09:15:00Z",
    read_time: "3 min",
    category: "Horas Extras",
    tags: ["horas-extras", "cálculo", "adicional", "jornada"],
    featured: false,
    image: "/images/blog/placeholder.jpg",
    created_at: "2025-01-05T09:15:00Z",
    updated_at: "2025-01-05T09:15:00Z"
  }
];

export const getMockBlogPost = (slug: string): BlogPost | null => {
  return mockBlogPosts.find(post => post.slug === slug) || null;
};
